import React from 'react'
import { useNavigate } from 'react-router-dom'
import {
  CommandPaletteOption,
  DetailsDescription,
  DetailsTitle,
  getValue,
  RouteEntry,
  SectionTitleWithButton,
} from '../CommandPalette_Utils'

type RouteDetailsProps = {
  route: RouteEntry
  onNavigate: () => void
  onItemInteraction: (item: CommandPaletteOption) => void
}

export function RouteDetails({
  route,
  onNavigate,
  onItemInteraction,
}: RouteDetailsProps) {
  const navigate = useNavigate()
  const path = String(route.path || '')

  const handleNavigate = () => {
    onItemInteraction(route)
    navigate(path)
    onNavigate()
  }

  // Construct full URL
  const fullUrl = `${window.location.origin}${path}`

  return (
    <>
      <DetailsTitle>{getValue(route.label)} Page</DetailsTitle>
      <DetailsDescription>
        <div
          style={{
            padding: '8px 0',
            borderBottom: '1px solid #e5e7eb',
          }}
        >
          <SectionTitleWithButton
            title="Navigation"
            buttonText="Go to Page"
            onButtonClick={handleNavigate}
            buttonTitle="Navigate to this route"
          />
          <div
            style={{
              marginTop: '8px',
              fontStyle: 'italic',
              color: '#6b7280',
              fontSize: '12px',
            }}
          >
            Go to <a href={fullUrl}>{fullUrl}</a>
          </div>
        </div>
      </DetailsDescription>
    </>
  )
}
